import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OutreachPage } from "@/features/outreach/OutreachPage";

const search = z.object({
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/outreach/")({
  validateSearch: search,
  component: () => <OutreachPage search={Route.useSearch()} />,
});
